import React, { lazy, Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/UI/Button';
// Social Media Button Component - reusable for all spotlight features
const SocialButton = ({
  url
}: {
  url: string;
}) => {
  // Detect platform from URL
  const getPlatformInfo = (url: string) => {
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.includes('linkedin.com')) {
      return {
        name: 'LinkedIn',
        bgColor: 'bg-[#0A66C2]',
        hoverColor: 'hover:bg-[#004182]',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2788">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-2789" />
          </svg>
      };
    }
    if (lowerUrl.includes('instagram.com')) {
      return {
        name: 'Instagram',
        bgColor: 'bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737]',
        hoverColor: 'hover:opacity-90',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2790">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" data-id="element-2791" />
          </svg>
      };
    }
    if (lowerUrl.includes('twitter.com') || lowerUrl.includes('x.com')) {
      return {
        name: 'X (Twitter)',
        bgColor: 'bg-black',
        hoverColor: 'hover:bg-gray-800',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2792">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-2793" />
          </svg>
      };
    }
    if (lowerUrl.includes('youtube.com')) {
      return {
        name: 'YouTube',
        bgColor: 'bg-[#FF0000]',
        hoverColor: 'hover:bg-[#cc0000]',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2794">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-2795" />
          </svg>
      };
    }
    if (lowerUrl.includes('spotify.com')) {
      return {
        name: 'Spotify',
        bgColor: 'bg-[#1DB954]',
        hoverColor: 'hover:bg-[#1aa34a]',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2796">
            <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" data-id="element-2797" />
          </svg>
      };
    }
    // Default website
    return {
      name: 'Website',
      bgColor: 'bg-gray-700',
      hoverColor: 'hover:bg-gray-600',
      icon: <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-2798">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" data-id="element-2799" />
        </svg>
    };
  };
  const platformInfo = getPlatformInfo(url);
  return <a href={url} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center px-4 py-2 rounded-lg text-white font-medium transition-all ${platformInfo.bgColor} ${platformInfo.hoverColor}`} data-id="element-2800">
      {platformInfo.icon}
      Connect on {platformInfo.name}
    </a>;
};
export const DrOsagieSpotlight = () => {
  // Social media links for this feature
  const socialLinks = ['https://www.youtube.com/@MrUpgradeGlobal', 'https://www.instagram.com/wisdomcounsellin', 'https://www.x.com/@wisdomcounselin', 'https://www.linkedin.com/in/osagie-alex-amayanvbo-767760aa/', 'https://open.spotify.com/show/6PZICVckQZEFlMF5CYjIjx?si=iUAi9e6DTxmeZ-zFFahx6A'];
  return <div className="pt-20 bg-white min-h-screen" data-id="element-2801">
      {/* Hero Section */}
      <section className="relative py-16 border-b border-gray-200" data-id="element-2802">
        <div className="absolute inset-0 z-0" data-id="element-2803">
          <img src="https://cdn.magicpatterns.com/uploads/4PLoghNtqGw9RzWLL9Eoee/1.png" alt="Dr. Osagie Alex" className="w-full h-full object-cover" loading="lazy" data-id="element-2804" />
          <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-2805"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-2806">
          <div className="max-w-4xl mx-auto" data-id="element-2807">
            <Link to="/salon-spotlight" className="inline-flex items-center text-white hover:text-gray-200 mb-6" data-id="element-2808">
              <ArrowLeft size={20} className="mr-2" data-id="element-2809" />
              Back to Salon Spotlight
            </Link>
            <div className="text-white" data-id="element-2810">
              <p className="text-sm mb-4" data-id="element-2811">SALON SPOTLIGHT</p>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-2812">
                Dr. Osagie Alex
              </h1>
              <p className="text-2xl md:text-3xl font-medium" data-id="element-2813">
                The Discipline of Becoming More
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16" data-id="element-2814">
        <div className="container mx-auto px-4" data-id="element-2815">
          <div className="max-w-4xl mx-auto" data-id="element-2816">
            <article className="prose prose-lg max-w-none" data-id="element-2817">
              <p className="text-xl text-gray-700 leading-relaxed mb-8" data-id="element-2818">
                Some people speak about growth. Others build a life around it.
                Dr. Osagie Alex belongs firmly in the second category.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2819">
                An Upgrade Mastery Practitioner and founder of TWCC Resources,
                Dr. Osagie has devoted his work to one central idea: good is
                never the destination. For him, life is an ongoing invitation to
                upgrade—to move deliberately from who you are now toward who you
                are capable of becoming.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2820">
                He describes himself simply, but boldly, as "the shortest
                distance between who you are now and who you can become." And
                that framing captures the heart of his work.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2821">
                His Story: Refusing to Settle
              </h2>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2822">
                Dr. Osagie's journey was inspired by a conviction that there is
                always more available—more growth, more clarity, more capacity.
                What he resists most is not failure, but smallness. The quiet
                decision to settle when greatness is accessible is something he
                actively challenges in the people he works with.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2823">
                That belief became the foundation of his practice. Through
                teaching, mentoring, content creation, and community engagement,
                he helps individuals recognise when "good" has become a comfort
                zone—and gives them the tools to move beyond it.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2824">
                The Work: Upgrade as a Way of Life
              </h2>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2825">
                As an Upgrade Mastery Practitioner, Dr. Osagie works in the
                space of personal development with a clear focus: helping people
                become the most upgraded version of themselves. His approach is
                not motivational noise; it is a discipline.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2826">
                Upgrade, in his language, is not cosmetic. It is internal. When
                people upgrade how they think, decide, and act, everything
                connected to them begins to change—relationships, leadership,
                work, and influence.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2827">
                His work lives across platforms—YouTube, Instagram, X, LinkedIn,
                and Spotify—where he shares insight, counsel, and frameworks
                that challenge people to grow with intention and speed.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2828">
                Culture, Impact, and Influence
              </h2>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2829">
                Dr. Osagie believes personal upgrade has a multiplier effect.
                When one person commits to becoming better, the systems they
                belong to improve as well. Families shift. Organisations evolve.
                Communities rise.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2830">
                The impact of his work often shows up in feedback—stories of
                people making clearer decisions, stepping into leadership, or
                realigning their lives with purpose. Those moments reaffirm his
                calling: helping people realise that stagnation is optional.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2831">
                His influences reflect the depth of his thinking—the Bible, Vusi
                Thembakwayo, Bishop Wale Ajayi, Apostle Femi Lazarus, and Bishop
                Benson Idahosa—voices rooted in conviction, leadership, and
                transformation.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2832">
                What He's Open To
              </h2>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2833">
                Dr. Osagie is open to collaborations with individuals and
                communities who are ready to leave good behind and upgrade. For
                him, collaboration is less about numbers and more about
                readiness—a shared hunger for growth and expansion.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2834">
                Words He Lives By
              </h2>

              <p className="text-xl text-gray-700 leading-relaxed font-medium italic border-l-4 border-gray-300 pl-6 my-12" data-id="element-2835">
                "Just start. You will get clarity along the journey. Start
                small, think big, and grow fast."
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2836">
                It's advice shaped by experience. Progress begins with movement,
                not perfection.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2837">
                Why We Spotlight Him
              </h2>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2838">
                Dr. Osagie Alex embodies what The Networking Salon values:
                intentional growth, clarity of purpose, and the courage to
                demand more from life. He reminds us that personal development
                is not a phase—it's a lifelong responsibility.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2839">
                This spotlight celebrates a man committed to helping others
                cross the distance between potential and performance, one
                upgrade at a time.
              </p>
            </article>

            {/* Connect Section */}
            <div className="mt-12 p-8 bg-gray-50 rounded-lg border-2 border-gray-200" data-id="element-2840">
              <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2841">
                Connect with Dr. Osagie Alex
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-2842">
                Follow Dr. Osagie across his platforms for insights on personal
                development, upgrade mastery, and intentional growth.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-2843">
                {socialLinks.map((link, index) => <SocialButton key={index} url={link} data-id="element-2844" />)}
              </div>
            </div>

            {/* Back Button */}
            <div className="mt-16 pt-8 border-t-2 border-gray-300" data-id="element-2845">
              <Link to="/salon-spotlight" data-id="element-2846">
                <Button variant="outline" data-id="element-2847">
                  <ArrowLeft size={20} className="mr-2" data-id="element-2848" />
                  Back to Salon Spotlight
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
};